import { type ColumnDef } from '@tanstack/react-table';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { Dinheiro } from '@/ui/components/dinheiro';
import { Status } from '@/ui/components/status';
import { type MetaColuna } from '@/ui/components/tabela-dados';
import { type Pendencia } from '@fiscoai/contracts';

import { destinoDa, PRIORIDADE, TIPO_PENDENCIA } from './rotulos';

const meta = (m: MetaColuna) => m;

export const colunasPendencias: ColumnDef<Pendencia>[] = [
  {
    id: 'prioridade',
    header: 'Prioridade',
    meta: meta({ largura: '7rem' }),
    cell: ({ row }) => {
      const p = PRIORIDADE[row.original.prioridade];
      return <Status tom={p.tom}>{p.rotulo}</Status>;
    },
  },
  {
    id: 'pendencia',
    header: 'Pendência',
    cell: ({ row }) => (
      <span className="grid min-w-0 leading-tight">
        <span className="truncate font-medium">{row.original.mensagem}</span>
        <span className="truncate text-xs text-texto-fraco">
          {TIPO_PENDENCIA[row.original.tipo]}
          {row.original.emitente ? ` · ${row.original.emitente}` : ''}
        </span>
      </span>
    ),
  },
  {
    id: 'idade',
    header: 'Idade',
    meta: meta({ alinhar: 'direita', largura: '5rem' }),
    cell: ({ row }) =>
      row.original.idadeDias === null ? (
        <span className="text-texto-fraco">—</span>
      ) : (
        <span className="tabular text-texto-suave">{row.original.idadeDias} d</span>
      ),
  },
  {
    id: 'valor',
    header: 'Valor',
    meta: meta({ alinhar: 'direita', largura: '8rem' }),
    cell: ({ row }) =>
      row.original.valor === null ? (
        <span className="text-texto-fraco">—</span>
      ) : (
        <Dinheiro valor={row.original.valor} />
      ),
  },
  {
    id: 'acao',
    header: 'O que fazer',
    meta: meta({ largura: '15rem' }),
    cell: ({ row }) => (
      <Link
        to={destinoDa(row.original)}
        className="group inline-flex items-center gap-1 text-sm text-marca hover:underline"
      >
        {row.original.acaoSugerida}
        <ArrowRight
          className="size-3.5 transition-transform duration-[var(--duracao-rapida)] group-hover:translate-x-0.5"
          aria-hidden
        />
      </Link>
    ),
  },
];
